import requestResetPassword from './requestResetPassword';

const api = { requestResetPassword };

export default api;
